/**
 * Ekrandaki bir noktanın yüzey bilgisi ve iki yüzeyin benzerliği.
 * Bütün geçişler (doldurma, geçmiş, yumuşatma) aynı kuralı kullanır.
 */

import { abs, dot, exp, max, pow, getViewPosition } from 'three/tsl';

/** Doku içinde "bu pikselde bu kare veri yok" işareti (alfa kanalı). */
export const NO_DATA = - 1;

// Düzlem uzaklığı, kameraya uzaklığın %2'si olunca ağırlık 1/e'ye düşer.
const PLANE_TOLERANCE = 0.02;
// Normal benzerliği: dot^16 → 30° farkta ağırlık ~0,1.
const NORMAL_POWER = 16;

/**
 * @param {Object} node - SparseGiV2Node
 * @param {Node<vec2>} uv - ekran uv'si
 * @return {{ isSky: Node<bool>, position: Node<vec3>, normal: Node<vec3> }} görüş uzayında
 */
export function readSurface( node, uv ) {

	const depth = node.depthNode.sample( uv ).r.toVar();

	// Gökyüzü kuralı SSGINode ile aynı: yalnız gerçekten derinliği olmayan piksel.
	// (Eski seyrek GI 0,999 kullanıyordu; yakın sınır 0,01 m iken ~10 m'den uzağı gökyüzü sayıyordu.)
	const isSky = node._reversedDepth ? depth.lessThanEqual( 1e-5 ) : depth.greaterThanEqual( 1.0 );

	return {
		isSky,
		position: getViewPosition( uv, depth, node._cameraProjectionMatrixInverse ).toVar(),
		normal: node.normalNode.sample( uv ).rgb.normalize().toVar(),
	};

}

/**
 * İki yüzey aynı yüzey mi? 1 = aynı düzlem ve yön, 0'a yakın = farklı.
 * Derinlik farkı yerine düzlem uzaklığı: eğik bakılan zeminde de doğru çalışır.
 */
export function surfaceSimilarity( center, other ) {

	const distanceToCamera = max( center.position.z.negate(), 0.1 );
	const planeDistance = abs( dot( center.normal, other.position.sub( center.position ) ) ).div( distanceToCamera );

	const planeWeight = exp( planeDistance.div( PLANE_TOLERANCE ).negate() );
	const normalWeight = pow( max( dot( center.normal, other.normal ), 0 ), NORMAL_POWER );

	return planeWeight.mul( normalWeight );

}
